
import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    TextField,
    Grid,
    Chip,
    Button,
    Stack,
     FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import DownloadIcon from "@mui/icons-material/Download";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { getProductionPlanHours } from "../../services/ProductionPlanHoursService";

const ProductionPlanHours = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
const monthOptions = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

const [selectedMonths, setSelectedMonths] = useState([
    "October",
    "November",
    "December",
]);
    // =========================================================
    // FETCH DATA
    // =========================================================

 const fetchData = async (months = selectedMonths) => {
    try {
        setLoading(true);

        const response = await getProductionPlanHours(months);

        if (response?.data?.status) {
            setRows(response.data.data || []);
        } else {
            setRows([]);
        }
    } catch (error) {
        console.error("Production plan hours error:", error);
        setRows([]);
    } finally {
        setLoading(false);
    }
    };

useEffect(() => {
    fetchData(selectedMonths);
}, []);

    // =========================================================
    // SEARCH
    // =========================================================

    const filteredRows = rows.filter((row) =>
        JSON.stringify(row)
            .toLowerCase()
            .includes(searchText.toLowerCase())
    );

    // =========================================================
    // SUMMARY
    // =========================================================

    const totalMonthlyTarget = rows.reduce(
        (sum, row) => sum + Number(row.monthly_target || 0),
        0
    );

    const totalOperators = rows.reduce(
        (sum, row) => sum + Number(row.required_operator || 0),
        0
    );

    const totalManpower = rows.reduce(
        (sum, row) => sum + Number(row.required_manpower || 0),
        0
    );

    //const totalMachines = rows.reduce(
       //// (sum, row) => sum + Number(row.required_machines || 0),
       // 0
    //);

    const totalOvertimeHours = rows.reduce(
        (sum, row) => sum + Number(row.overtime_hours || 0),
        0
    );

      const qty_produced = rows.reduce(
        (sum, row) => sum + Number(row.qty_produced || 0),
        0
    );
          const qty_pending = rows.reduce(
        (sum, row) => sum + Number(row.qty_pending || 0),
        0
    );

    // =========================================================
    // NUMBER FORMATTER
    // =========================================================

    const formatNumber = (value) => {
        if (
            value === null ||
            value === undefined ||
            value === ""
        ) {
            return "-";
        }

        const number = Number(value);

        if (Number.isNaN(number)) {
            return value;
        }

        return number.toLocaleString(undefined, {
            maximumFractionDigits: 2,
        });
    };
    const columnGroupingModel = [
        {
            groupId: "production_8_hours",
            headerName: "8 Hours Production Plan",
            headerClassName: "group-header-8-hours",
            children: [
                { field: "capacity_8_hours" },
                { field: "shortfall_after_8_hours" },
                { field: "extra_hours_after_8_hours" },
                { field: "required_machines_8_hours" },
            ],
        },
        {
            groupId: "production_12_hours",
            headerName: "12 Hours Production Plan",
            headerClassName: "group-header-12-hours",
        
            children: [
                { field: "capacity_12_hours" },
                { field: "shortfall_after_12_hours" },

                { field: "extra_hours_after_12_hours" },
                { field: "required_machines_12_hours" },
            ],
        },
       {
        groupId: "production_24_hours",
        headerName: "24 Hours Production Plan",
        headerClassName: "group-header-24-hours",
        children: [
            { field: "capacity_24_hours" },
            { field: "required_machines_24_hours" },
        ],
        },
        ];
        // =========================================================
    // CAPACITY STATUS
    // =========================================================

    const renderCapacityStatus = (status) => {
        if (!status) {
            return "-";
        }

        let color = "default";

        if (status === "ACHIEVABLE_IN_8_HOURS") {
            color = "success";
        } else if (status === "REQUIRES_EXTRA_HOURS") {
            color = "warning";
        } else if (status === "REQUIRES_MORE_THAN_12_HOURS") {
            color = "error";
        }

        return (
            <Chip
                label={String(status).replaceAll("_", " ")}
                color={color}
                size="small"
            />
        );
    };

    // =========================================================
    // DATA GRID COLUMNS
    // =========================================================

    const columns = [
        

        /*   {
            field: "product_code",
            headerName: "Product Code",
            width: 130,
        },
        */
        {
            field: "item",
            headerName: "Item",
            minWidth: 180,
            flex: 1,
        },
     
        {
            field: "month",
            headerName: "Month",
            width: 90,
        },
/*
        {
            field: "machine_code",
            headerName: "Machine",
            width: 140,
            renderCell: (params) =>
                params.value ? (
                    params.value
                ) : (
                    <Chip
                        label="Not Planned"
                        color="error"
                        size="small"
                    />
                ),
        },

        {
            field: "type",
            headerName: "Die Type",
            width: 100,
        },

        {
            field: "max_cycles",
            headerName: "Max Cycles",
            width: 100,
        },
       
        {
            field: "machine_capacity_24_hours",
            headerName: "Capacity 24Hrs",
            width: 135,
            valueFormatter: (value) =>
                formatNumber(value),
        }, */
        {
            field: "monthly_target",
            headerName: "Monthly Target",
            width: 125,
            valueFormatter: (value) =>
                formatNumber(value),
        },
        
         {
            field: "working_days",
            headerName: "WorkingDays",
            width: 90,
        },

  
          {
            field: "machine_capacity_per_hour",
            headerName: "PerHrs",
            width: 80,
            valueFormatter: (value) =>
                formatNumber(value),
        },
/*
        {
            field: "qty_produced",
            headerName: "Produced",
            width: 90,
            valueFormatter: (value) =>
                formatNumber(value),
        },
          {
            field: "qty_pending",
            headerName: "Pending",
            width: 90,
            valueFormatter: (value) =>
                formatNumber(value),
        },
        {
            field: "working_days",
            headerName: "WorkingDays",
            width: 90,
        },

        {
            field: "daily_target",
            headerName: "DailyTarget",
            width: 100,
            valueFormatter: (value) =>
                formatNumber(value),
        },

        // =====================================================
        // MACHINE CAPACITY
        // =====================================================

        {
            field: "machine_capacity_per_hour",
            headerName: "PerHrs",
            width: 80,
            valueFormatter: (value) =>
                formatNumber(value),
        },

     */



        // =====================================================
        // SINGLE MACHINE CAPACITY
        // =====================================================

        {
            field: "capacity_8_hours",
            headerName: "1Machine8Hr",
            width: 125,
            valueFormatter: (value) =>
                formatNumber(value),
        },
         {
            field: "shortfall_after_8_hours",
            headerName: "Remaining Qty",
            width: 100,
            valueFormatter: (value) =>
                formatNumber(value),
        },

        {
            field: "extra_hours_after_8_hours",
            headerName: "ExtraHrs Needed",
            width: 100,
            valueFormatter: (value) =>
                formatNumber(value),
        },

  {
            field: "required_machines_8_hours",
            headerName: "Extra Machines8Hr",
            width: 120,
            valueFormatter: (value) =>
                formatNumber(value),
        },


        {
            field: "capacity_12_hours",
            headerName: "1Machine12Hr",
            width: 130,
            valueFormatter: (value) =>
                formatNumber(value),
        },
        
 {
            field: "shortfall_after_12_hours",
            headerName: "Remaining Qty",
            width: 100,
            valueFormatter: (value) =>
                formatNumber(value),
        },

        {
            field: "extra_hours_after_12_hours",
            headerName: "ExtraHrs Needed",
            width: 110,
            valueFormatter: (value) =>
                formatNumber(value),
        },
         {
            field: "required_machines_12_hours",
            headerName: "Extra Machines12Hr",
            width: 125,
            valueFormatter: (value) =>
                formatNumber(value),
        },


        {
            field: "capacity_24_hours",
            headerName: "1Machine24Hr",
            width: 120,
            valueFormatter: (value) =>
                formatNumber(value),
        },
          {
            field: "required_machines_24_hours",
            headerName: "Extra Machines24Hr",
            width: 120,
            valueFormatter: (value) =>
                formatNumber(value),
        },

        // =====================================================
        // TOTAL AVAILABLE CAPACITY
        // =====================================================

        //{
          //  field: "total_capacity_8_hours",
           // headerName: "Total Cap 8H",
           // width: 125,
           // valueFormatter: (value) =>
            //    formatNumber(value),
        //},

        //{
          //  field: "total_capacity_12_hours",
           // headerName: "Total Cap 12H",
           // width: 125,
           // valueFormatter: (value) =>
           ///     formatNumber(value),
        //},

        ///{
           // field: "total_capacity_24_hours",
           // headerName: "Total Cap 24H",
           // width: 125,
           // valueFormatter: (value) =>
           //     formatNumber(value),
      //  },

        // =====================================================
        // REQUIRED MACHINES
        // =====================================================

      
       
      

      //  {
        //    field: "required_machines",
          //  headerName: "Required Machines",
          //  width: 140,
          //  valueFormatter: (value) =>
          //      formatNumber(value),
       // },

        // =====================================================
        // PRODUCTION 8 HOURS
        // =====================================================

       /* {
            field: "production_8_hours",
            headerName: "Production 8H",
            width: 125,
            valueFormatter: (value) =>
                formatNumber(value),
        },

        {
            field: "shortfall_after_8_hours",
            headerName: "Shortfall 8H",
            width: 125,
            valueFormatter: (value) =>
                formatNumber(value),
        },

        {
            field: "extra_hours_after_8_hours",
            headerName: "Extra Hrs After 8H",
            width: 145,
            valueFormatter: (value) =>
                formatNumber(value),
        },

        // =====================================================
        // PRODUCTION 12 HOURS
        // =====================================================

        {
            field: "production_12_hours",
            headerName: "Production 12H",
            width: 130,
            valueFormatter: (value) =>
                formatNumber(value),
        },

        {
            field: "shortfall_after_12_hours",
            headerName: "Shortfall 12H",
            width: 130,
            valueFormatter: (value) =>
                formatNumber(value),
        },

        {
            field: "extra_hours_after_12_hours",
            headerName: "Extra Hrs After 12H",
            width: 150,
            valueFormatter: (value) =>
                formatNumber(value),
        },
        */

        // =====================================================
        // TOTAL HOURS
        // =====================================================

     
        {
            field: "capacity_status",
            headerName: "Capacity Status",
            width: 300,
            renderCell: (params) =>
                renderCapacityStatus(params.value),
        },
         {
            field: "overtime_required",
            headerName: "OT",
            width: 70,
            renderCell: (params) =>
                Number(params.value) === 1 ? (
                    <Chip
                        label="YES"
                        color="warning"
                        size="small"
                    />
                ) : (
                    <Chip
                        label="NO"
                        color="success"
                        size="small"
                    />
                ),
        },

        
        {
            field: "qty_produced",
            headerName: "Produced",
            width: 90,
            valueFormatter: (value) =>
                formatNumber(value),
        },
          {
            field: "qty_pending",
            headerName: "Pending",
            width: 90,
            valueFormatter: (value) =>
                formatNumber(value),
        },

          {
            field: "remaining_target",
            headerName: "Total Target",
            width: 125,
            valueFormatter: (value) =>
                formatNumber(value),
        },

       

        // =====================================================
        // MACHINE CAPACITY
        // =====================================================

      

        // =====================================================
        // MANPOWER
        // =====================================================
        {
            field: "required_operator",
            headerName: "Operators",
            width: 100,
            valueFormatter: (value) =>
                formatNumber(value),
        },
        {
            field: "required_manpower",
            headerName: "Manpower",
            width: 110,
            valueFormatter: (value) =>
                formatNumber(value),
        },
         {
            field: "machine_code",
            headerName: "Machine",
            width: 140,
            renderCell: (params) =>
                params.value ? (
                    params.value
                ) : (
                    <Chip
                        label="Not Planned"
                        color="error"
                        size="small"
                    />
                ),
        },

        {
            field: "type",
            headerName: "Die Type",
            width: 100,
        },

        {
            field: "max_cycles",
            headerName: "Max Cycles",
            width: 100,
        },
       
       
        // =====================================================
        // NORMAL SHIFT
        // =====================================================
        // =====================================================
        // OVERTIME
        // =====================================================

    ];
    // =========================================================
    // EXCEL EXPORT
    // =========================================================
    const exportToExcel = async () => {
        try {
            if (!rows || rows.length === 0) {
                alert("No data available to export.");
                return;
            }

            const workbook = new ExcelJS.Workbook();

            workbook.creator = "Production Management System";
            workbook.created = new Date();
            workbook.modified = new Date();

            const worksheet =
                workbook.addWorksheet("Production Plan Hours");
            // -------------------------------------------------
            // Get ALL fields returned by API
            // -------------------------------------------------
            const allFields = [
                ...new Set(
                    rows.flatMap((row) =>
                        Object.keys(row || {})
                    )
                ),
            ];
            // -------------------------------------------------
            // Header names
            // -------------------------------------------------
            const headerNames = allFields.map((field) => {
                return field
                    .replaceAll("_", " ")
                    .replace(/\b\w/g, (char) =>
                        char.toUpperCase()
                    );
            });
            // -------------------------------------------------
            // Add header
            // -------------------------------------------------

            worksheet.addRow(headerNames);
            // -------------------------------------------------
            // Add all data
            // -------------------------------------------------
           rows.forEach((row) => {
                const values = allFields.map((field) => {
                    const value = row?.[field];

                    if (
                        value === null ||
                        value === undefined
                    ) {
                        return "";
                    }

                    return value;
                });

                worksheet.addRow(values);
            });

            // -------------------------------------------------
            // Header formatting
            // -------------------------------------------------

            const headerRow = worksheet.getRow(1);

            headerRow.font = {
                bold: true,
                color: {
                    argb: "FFFFFFFF",
                },
            };

            headerRow.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                    argb: "1F4E78",
                },
            };

            headerRow.alignment = {
                vertical: "middle",
                horizontal: "center",
            };

            headerRow.height = 25;

            // -------------------------------------------------
            // Borders
            // -------------------------------------------------

            worksheet.eachRow((row) => {
                row.eachCell((cell) => {
                    cell.border = {
                        top: {
                            style: "thin",
                            color: {
                                argb: "D9E1F2",
                            },
                        },
                        left: {
                            style: "thin",
                            color: {
                                argb: "D9E1F2",
                            },
                        },
                        bottom: {
                            style: "thin",
                            color: {
                                argb: "D9E1F2",
                            },
                        },
                        right: {
                            style: "thin",
                            color: {
                                argb: "D9E1F2",
                            },
                        },
                    };

                    cell.alignment = {
                        vertical: "middle",
                    };
                });
            });

            // -------------------------------------------------
            // Freeze header
            // -------------------------------------------------

            worksheet.views = [
                {
                    state: "frozen",
                    ySplit: 1,
                },
            ];

            // -------------------------------------------------
            // Auto width
            // -------------------------------------------------

            allFields.forEach((field, index) => {
                let maxLength =
                    headerNames[index].length;

                rows.forEach((row) => {
                    const value = row?.[field];

                    if (
                        value !== null &&
                        value !== undefined
                    ) {
                        maxLength = Math.max(
                            maxLength,
                            String(value).length
                        );
                    }
                });

                worksheet.getColumn(index + 1).width =
                    Math.min(
                        Math.max(maxLength + 2, 12),
                        35
                    );
            });

            // -------------------------------------------------
            // Excel filters
            // -------------------------------------------------

            worksheet.autoFilter = {
                from: "A1",
                to: `${worksheet.getColumn(
                    allFields.length
                ).letter}1`,
            };

            // -------------------------------------------------
            // Create file
            // -------------------------------------------------

            const buffer =
                await workbook.xlsx.writeBuffer();

            const blob = new Blob([buffer], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const date = new Date()
                .toISOString()
                .slice(0, 10);

            saveAs(
                blob,
                `Production_Plan_Hours_${date}.xlsx`
            );
        } catch (error) {
            console.error(
                "Excel export error:",
                error
            );

            alert(
                "Unable to export Excel. Please check the console."
            );
        }
    };

    // =========================================================
    // UI
    // =========================================================

    return (
        <>
            <Stack
                direction={{
                    xs: "column",
                    sm: "row",
                }}
                justifyContent="space-between"
                alignItems={{
                    xs: "stretch",
                    sm: "center",
                }}
                spacing={1}
                sx={{ mb: 1 }}
            >
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 600,
                    }}
                >
                    Production Planning
                </Typography>

                <Button
                    variant="contained"
                    color="success"
                    startIcon={<DownloadIcon />}
                    onClick={exportToExcel}
                    disabled={
                        loading || rows.length === 0
                    }
                >
                    Export Excel
                </Button>
            </Stack>

            {/* =================================================
                SUMMARY CARDS
            ================================================= */}

            <Grid
                container
                spacing={1}
                sx={{ mb: 1 }}
            >
                <Grid item xs={12} sm={6} md={3}>
                    <Card>
                        <CardContent>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                            >
                                Total Monthly Target
                            </Typography>

                            <Typography variant="h5">
                                {totalMonthlyTarget.toLocaleString()}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Card>
                        <CardContent>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                            >
                                Total Monthly Produced
                            </Typography>

                            <Typography variant="h5">
                                {qty_produced.toLocaleString()}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Card>
                        <CardContent>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                            >
                                Total  Pending
                            </Typography>

                            <Typography variant="h5">
                                {qty_pending.toLocaleString()}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Card>
                        <CardContent>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                            >
                                Total Operators
                            </Typography>

                            <Typography variant="h5">
                                {totalOperators.toLocaleString()}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Card>
                        <CardContent>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                            >
                                Total Manpower
                            </Typography>

                            <Typography variant="h5">
                                {totalManpower.toLocaleString()}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Card>
                        <CardContent>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                            >
                                Total OT Hours
                            </Typography>

                            <Typography variant="h5">
                                {totalOvertimeHours.toLocaleString(
                                    undefined,
                                    {
                                        maximumFractionDigits: 2,
                                    }
                                )}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* =================================================
                DATA GRID
            ================================================= */}

  <Card>
    <CardContent>
        {/* Search and Month Filter in Same Line */}
        <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            alignItems={{ xs: "stretch", md: "center" }}
            sx={{ mb: 2 }}
        >
            <TextField
                size="small"
                label="Search By Item, Products..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{
                    flex: 1,
                    minWidth: 200,
                }}
            />

            <FormControl
                size="small"
                sx={{
                    minWidth: 280,
                    flex: 1,
                }}
            >
                <InputLabel id="production-months-label">
                    Select Months
                </InputLabel>

                <Select
                    labelId="production-months-label"
                    multiple
                    value={selectedMonths}
                    onChange={(event) => {
                        const value = event.target.value;

                        setSelectedMonths(
                            typeof value === "string"
                                ? value.split(",")
                                : value
                        );
                    }}
                    input={<OutlinedInput label="Select Months" />}
                    renderValue={(selected) => selected.join(", ")}
                >
                    {monthOptions.map((month) => (
                        <MenuItem key={month} value={month}>
                            {month}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <Button
                variant="contained"
                onClick={() => fetchData(selectedMonths)}
                disabled={loading}
                sx={{ minWidth: 120 }}
            >
                Apply Filter
            </Button>

            <Button
                variant="outlined"
                onClick={() => {
                    setSelectedMonths([]);
                    fetchData([]);
                }}
                disabled={loading}
                sx={{ minWidth: 110 }}
            >
                Clear Filter
            </Button>
        </Stack>

        {/* Data Grid */}
        <DataGrid
            rows={filteredRows}
            columns={columns}
            loading={loading}
            getRowId={(row) => row.id}
             columnGroupingModel={columnGroupingModel}
            showColumnVerticalBorder
            showCellVerticalBorder
            pageSizeOptions={[10, 25, 50, 100]}
            initialState={{
                pagination: {
                    paginationModel: {
                        page: 0,
                        pageSize: 10,
                    },
                },
            }}
            density="compact"
            disableRowSelectionOnClick
            autoHeight
            sx={{
                border: 0,
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f5f5f5",
                    fontWeight: 700,
                    borderBottom: "2px solid #d0d0d0",
                },
                "& .MuiDataGrid-cell": {
                    borderColor: "#f0f0f0",
                },
            }}
        />
    </CardContent>
</Card>
        </>
    );
};

export default ProductionPlanHours;

